import { parseISO } from "date-fns";
import { z } from "zod";

const FormSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  version: z.number().optional(),
});

const BusinessFormSchema = FormSummarySchema.extend({
  businessId: z.string(),
  versionId: z.string(),
  version: z.number(),
  definition: z.string(),
  createdAt: z.date(),
  modifiedAt: z.date(),
});

const FormDtoSchema = z.object({
  id: z.string(),
  business_id: z.string(),
  version_id: z.string(),
  version: z.number(),
  name: z.string(),
  definition: z.string(),
  created_at: z.string(),
  modified_at: z.string(),
});

export type FormDto = z.infer<typeof FormDtoSchema>;
export type FormSummary = z.infer<typeof FormSummarySchema>;
export type BusinessForm = z.infer<typeof BusinessFormSchema>;

export function fromFormDtoToForm(dto: FormDto): BusinessForm {
  const form = FormDtoSchema.parse(dto);
  return BusinessFormSchema.parse({
    id: form.id,
    businessId: form.business_id,
    versionId: form.version_id,
    version: form.version,
    name: form.name,
    definition: form.definition,
    createdAt: parseISO(form.created_at),
    modifiedAt: parseISO(form.modified_at),
  });
}
